var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 29.2419H27.12L33.5608 40.7548L26.4424 45L20.0013 33.4826L15.2549 24.9987L20.0013 16.5132L26.4421 5L33.5611 9.24065L27.12 20.7581H40.0001V29.2419Z",
    fill: "#0F8DC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000312338 29.2419H12.8826L6.44364 40.7548L13.5617 45L20.001 33.4826L24.7474 24.9987L20.001 16.5132L13.5617 5L6.44333 9.24065L12.8823 20.7581H0L0.000312338 29.2419Z",
    fill: "#6633CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.624e80fe2524eb48aeb2d9cffb25d704.svg";
export { ForwardRef as ReactComponent };